import type { MouseEvent } from 'react'

import * as classes from '@/styles/SkipToContent.css'

type SkipToContentProps = {
  targetId: string
}

export function SkipToContent({ targetId }: SkipToContentProps) {
  // Focused by hand rather than followed as a fragment link, which would leave the hash in the URL.
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    document.getElementById(targetId)?.focus()
  }

  return (
    <a href={`#${targetId}`} className={classes.link} onClick={handleClick}>
      Skip to main content
    </a>
  )
}
